export default [
  {
    path: '/contagemEstoque/',
    name: 'contagemEstoque',
    title: 'Contagem de estoque',
    component: () => import('../views/ContagemEstoqueView.vue'),
    redirect: { name: 'contagemEstoque-cadastrar' },
    children: [
      {
        path: 'add',
        name: 'contagemEstoque-cadastrar',
        component: () => import('../views/ContagemEstoqueFormView.vue'),
        meta: {
          title: 'Cadastrar contagem de estoque',
        },
      },
    ],
  },
];
